// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import { getFieldValue } from "@store/Extensions/Store/Components/ContactUsForm/ContactFormSelectors";
import React, { ChangeEvent, FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const fieldKey = "subscribeCheckBox";

const enum fields {
    label = "label",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    value: getFieldValue(state, fieldKey),
    subscribeState: state.components.contactUsForm.fieldValues["subscribeState"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SubscribeCheckBoxStyles {
    checkBoxGroup?: CheckboxGroupComponentProps;
    checkBox?: CheckboxPresentationProps;
}

export const SubscribeCheckBoxStyles: SubscribeCheckBoxStyles = {};

const styles = SubscribeCheckBoxStyles;

const SubscribeCheckBox: FC<Props> = ({ fields, subscribeState, setFieldValue }) => {
    const subscribeHandler = (_: React.SyntheticEvent, subscribeStateBool: boolean) => {
        setFieldValue({ key: "subscribeState", value: subscribeStateBool ? "true" : "false" });
    };

    return (
        <CheckboxGroup {...styles.checkBoxGroup}>
            <Checkbox {...styles.checkBox} checked={subscribeState === "true"} onChange={subscribeHandler}>
                {fields.label}
            </Checkbox>
        </CheckboxGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SubscribeCheckBox),
    definition: {
        group: "Contact Us",
        displayName: "Subscribe Check Box",
        icon: "square",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "I would like to receive Levitt-Safety email updates",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
